/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(private httpClient: HttpClient) {}

  getUserNotifications(type?) {
    const params = !type ? { take: '20', skip: '0' } : { take: '20', skip: '0', type };

    return this.handleGetResponse(this.httpClient.get(`${environment.apiHostname}/v1/user-notification`, { params }));
  }

  dismissNotification(notificationId: number) {
    if (!notificationId) {
      return;
    }
    return this.handleGetResponse(
      this.httpClient.delete(`${environment.apiHostname}/v1/user-notification/${notificationId}`)
    );
  }

  updateNotification(notification) {
    return this.handleGetResponse(
      this.httpClient.put(`${environment.apiHostname}/v1/user-notification/${notification.id}`, notification)
    );
  }

  dismissNotificationByUserTargetType(userId: number, targetId: number, type: string) {
    return this.handleGetResponse(
      this.httpClient.delete(
        `${environment.apiHostname}/v1/user-notification/by-user-target-type/${userId}/${targetId}/${type}`
      )
    );
  }

  dismissNotificationByPurchaseId(purchaseId: number) {
    return this.handleGetResponse(
      this.httpClient.delete(`${environment.apiHostname}/v1/user-notification/by-purchaseId/${purchaseId}`)
    );
  }

  /**
   * Generic method handler for when getting a response from server for a GET operation
   *
   * @returns {Observable<any>}
   */
  private handleGetResponse(methodCallResponse: Observable<object>) {
    return methodCallResponse.pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }
}
